import { Box } from "@mui/material";
import { useRouteLoaderData } from "react-router-dom"
import PageTitle from "../../../components/PageTitle";

export default function ObjectComfortables() {
    const hotelObj = useRouteLoaderData('obj_layout').hotelObj;
    return (
        <Box>
            <PageTitle title={`Зручності об'єкта: ${hotelObj?.name || hotelObj?.id || "ID"}`} />
            {hotelObj.icons.map((el, index) => (
                <Box key={index} sx={{m:1}}>#{index+1} {el}</Box>
            ))}
        </Box>
    )
}
